import { Injectable } from '@angular/core';
import { Clipboard } from '@capacitor/clipboard';

@Injectable()
export class ClipboardService {
	public async copy(valueToCopy: string): Promise<void> {
		// eslint-disable-next-line id-blacklist
		return await Clipboard.write({ string: valueToCopy });
	}
}
